import React, {Component} from 'react'
import Table from "../../../components/Table/Table";

class CustomerUserInfo extends Component {

	constructor(props) {
		super(props);

		this.state = {
			addUserModal: false,
			user: {
				firstName: '',
				lastName: '',
				username: ''
			},
			userList: [],
			page: 0,
			size: 10
		};

		this.arrangeData = this.arrangeData.bind(this);
	}

	componentDidMount() {
		let userList = this.props.userList;
		this.setState({
			userList
		})
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	openAddUserModal() {
		this.setState({
			addUserModal: true
		})
	}

	render() {
		const columns = [
			{
				Header: "Adı",
				accessor: "firstName",
				sortable: false
			},
			{
				Header: "Soyadı",
				accessor: 'lastName',
				sortable: false
			},
			{
				Header: "Kullanıcı Adı",
				accessor: 'username',
				sortable: false
			}
		];

		return (
			<div>
				<div className="col-sm-12 " style={{marginBottom:'20px'}}>
				</div>

				<div className="card-body">
					<Table
						columns={columns}
						content={this.state.userList}
						total={this.state.userList.length}
						paginationEnabled={false}
					/>
				</div>
			</div>
		)
	}
}

export default CustomerUserInfo